import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) => createStyles({
  extraSpacing: {
    marginTop: theme.spacing.unit * 2,
  },
});
